import type React from "react"
import { colourVar } from "../chakra/colourVar"

/** Background of rows rendered inside an expanded PaginatedTable row. */
export const EXPANDED_ROW_BACKGROUND = colourVar("row_expanded")

/** Cell under the expand chevron column: the tree strip linking expanded rows to their parent row. */
export const expandedRowSpacerCellStyle: React.CSSProperties = {
  padding: 0,
  width: "1.75rem",
  minWidth: "1.75rem",
  maxWidth: "1.75rem",
  background:
    `linear-gradient(to right, ${colourVar("tree_strip")} 0, ${colourVar("tree_strip")} 0.875rem, ${colourVar("tree_line")} 0.875rem, ${colourVar("tree_line")} calc(0.875rem + 1px), transparent calc(0.875rem + 1px), transparent 100%)`,
  borderBottom: `1px solid ${colourVar("row_divider")}`,
}
